import React from "react";
import PropTypes from "prop-types";
import styles from "./SelectButton.module.css";

export function SelectButton({ selected = false, onClick }) {
  return (
    <button
      type="button"
      className={selected ? styles.solid : styles.outlined}
      onClick={onClick}
    >
      {selected ? "Selected" : "Select"}
    </button>
  );
}

SelectButton.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};
